<template>
  <div>
    <v-row
      justify="end"
      align="center"
      no-gutters
      class="mb-2"
    >
      <v-col>
        <v-alert
          text
          prominent
          icon="mdi-information-outline"
          color="success"
          class="mb-0"
        >
          <v-row align="center" no-gutters>
            <v-col>
              <span
                class="headline ml-5"
                v-text="$t('criticalchain.finished.message')"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                :disabled="loadingPreviousStep"
                :loading="loadingPreviousStep"
                class="mx-1"
                color="primary"
                outlined
                @click="previousStep"
                v-text="$t('general.previous')"
              />
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
    <frappe-gantt
      v-model="internalTaskList"
      select-key="isOnCriticalChain"
      fixed
    />
  </div>
</template>

<script>
import FrappeGantt from '../components/FrappeGantt'
import AVAILABLE_ACTIONS from '../availableActions'

export default {
  name: 'FinishedContainer',
  components: {
    FrappeGantt,
  },
  props: {
    currentPlayer: {
      type: Object,
      required: true,
    },
  },
  inject: [
    'sendPlayerAction',
  ],
  data () {
    return {
      internalTaskList: [],
      loadingPreviousStep: false,
    }
  },
  watch: {
    currentPlayer: {
      immediate: true,
      handler () {
        this.internalTaskList = JSON.parse(JSON.stringify(this.currentPlayer.taskList))
      },
    },
  },
  methods: {
    async previousStep () {
      try {
        this.loadingPreviousStep = true
        await this.sendPlayerAction(AVAILABLE_ACTIONS.previousStep)
      }
      finally {
        this.loadingPreviousStep = false
      }
    },
  },
}
</script>
